module.exports = __webpack_public_path__ + "static/media/lapor.9caa0d68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Components/Nav-Home/lapor.svg
// module id = 78
// module chunks = 1